import React, { useState } from 'react';

import getModalContext from '../context/getModalContext';

import ListingNewModal from '../containers/Listings/ListingNewModal';
import ListingDeleteModal from '../containers/Listings/ListingDeleteModal';
import ContactDeleteModal from '../containers/People/ContactDeleteModal';
import PaymentModal from '../containers/Account/Billing/PaymentModal';
import PasswordModal from '../containers/Account/PasswordModale';
import UpgradePackageModal from '../containers/Account/UpgradePackageModal';
import UpgradePackageFeaturesModal from '../containers/Account/UpgradePackageFeaturesModal';

const ModalProvider: React.FC = ({ children }) => {
  const ModalContext = getModalContext();

  const [modalStates, setModalStates] = useState<Map<string, boolean>>(
    new Map()
  );
  const [contextProps, setContextProps] = useState<any>(null);

  const getModalState = (modal: string) => {
    return modalStates.get(modal);
  };

  const setModalState = (
    modal: string,
    state: boolean,
    contextProps: any = null
  ) => {
    if (contextProps) {
      setContextProps(contextProps);
    }
    setModalStates((prevState) => {
      return new Map(prevState).set(modal, state);
    });
  };

  return (
    <ModalContext.Provider value={{ getModalState, setModalState }}>
      {children}
      <PasswordModal
        show={modalStates.get('passwordModal') || false}
        account={contextProps?.account}
      />
      <ListingNewModal show={modalStates.get('listingNewModal') || false} />
      <ListingDeleteModal
        show={modalStates.get('listingDeleteModal') || false}
        listingId={contextProps?.listingId}
      />
      <ContactDeleteModal
        show={modalStates.get('contactDeleteModal') || false}
        contactId={contextProps?.contactId}
      />
      <PaymentModal
        show={modalStates.get('paymentModal') || false}
        account={contextProps?.account}
        items={contextProps?.items}
        redirect={contextProps?.redirect}
        listingId={contextProps?.listingId}
      />
      <UpgradePackageModal
        show={modalStates.get('upgradePackageModal') || false}
        account={contextProps?.account}
      />
      <UpgradePackageFeaturesModal
        show={modalStates.get('upgradePackageFeaturesModal') || false}
        account={contextProps?.account}
      />
    </ModalContext.Provider>
  );
};

export default ModalProvider;
